import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_to_applet_dependency_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  applet_hdr_guid_01 : fromDatatype.GuidDataFieldInterface;
  applet_hdr_guid_02 : fromDatatype.GuidDataFieldInterface;
  code : fromDatatype.VarcharDatatypeInterface;
  name : fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


export class bl_applet_to_applet_dependency_link_RowClass implements bl_applet_to_applet_dependency_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    applet_hdr_guid_01 : fromDatatype.GuidDataFieldInterface;
    applet_hdr_guid_02 : fromDatatype.GuidDataFieldInterface;
    code : fromDatatype.VarcharDatatypeInterface;
    name : fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
